import barba from "@barba/core";
import barbaPrefetch from "@barba/prefetch";

export function useBarba() {
  if (document.documentElement.dataset.prefetching === "false") {
    return;
  }
  if (
    document
      .querySelector("[data-barba='container']")
      ?.hasAttribute("data-barba-namespace")
  ) {
    barba.use(barbaPrefetch);
    barba.init({
      prevent: ({ el }) => {
        return !el.hasAttribute("data-barba-link");
      },
      transitions: [
        {
          async leave() {},
          async enter() {},
          after() {},
          afterEnter(data) {
            window.dispatchEvent(
              new CustomEvent("barba:afterEnter", {
                detail: data
              })
            );
            if(window.initDestiniBVConversionTracking){
              window.initDestiniBVConversionTracking();
            }

            const destiniScript = document.getElementById('destini-script');
            if (destiniScript) {
              const newScript = document.createElement('script');
              newScript.setAttribute('charset', 'utf-8');
              newScript.src = destiniScript.src;
              document.body.appendChild(newScript);
            }
          }
        }
      ]
    });
  }
}
